import { useState } from "react";
import { Check, X } from "lucide-react";
import { mediaUrl } from "../lib/api";

export const ModerationCard = ({ post, status, onModerate }) => {
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState("");

  return (
    <article data-testid={`moderation-card-${post.post_id}`} className="overflow-hidden rounded-3xl border border-[#E8DFD5] bg-white">
      {post.media_type === "video" ? (
        <video src={mediaUrl(post.media_url)} controls preload="metadata" className="aspect-square w-full object-cover" />
      ) : (
        <img src={mediaUrl(post.media_url)} alt={post.dog_name} className="aspect-square w-full object-cover" />
      )}
      <div className="p-5">
        <div className="flex items-baseline justify-between">
          <h3 className="font-display text-xl font-semibold text-[#2C2723]">{post.dog_name}</h3>
          <span className="text-xs text-[#8C7B6E]">di {post.author_name}</span>
        </div>
        {post.caption && <p className="mt-2 text-sm text-[#5C534B]">{post.caption}</p>}

        {rejecting ? (
          <div data-testid={`moderation-reject-panel-${post.post_id}`} className="mt-4 space-y-3">
            <textarea
              data-testid={`moderation-reject-reason-${post.post_id}`}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              maxLength={300}
              rows={2}
              placeholder="Motivo (facoltativo), es. foto sfocata: la famiglia lo leggerà nell'email"
              className="w-full rounded-2xl border border-[#E8DFD5] bg-[#FBF8F3] px-4 py-3 text-sm text-[#2C2723] outline-none transition-all placeholder:text-[#8C7B6E]/60 focus:border-[#B85328] focus:ring-2 focus:ring-[#B85328]/15"
            />
            <div className="flex gap-3">
              <button
                data-testid={`moderation-reject-confirm-${post.post_id}`}
                onClick={() => onModerate(post, "reject", reason)}
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#B85328] py-3 text-sm font-semibold text-white transition-all hover:bg-[#9a4420]"
              >
                <X size={15} /> Conferma rifiuto
              </button>
              <button
                data-testid={`moderation-reject-cancel-${post.post_id}`}
                onClick={() => setRejecting(false)}
                className="rounded-full border border-[#CFC0B2] px-5 py-3 text-sm font-semibold text-[#8C7B6E] transition-all hover:border-[#2C2723] hover:text-[#2C2723]"
              >
                Annulla
              </button>
            </div>
          </div>
        ) : (
          <div className="mt-4 flex gap-3">
            {status !== "approved" && (
              <button
                data-testid={`moderation-approve-${post.post_id}`}
                onClick={() => onModerate(post, "approve")}
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#4A6B5D] py-3 text-sm font-semibold text-white transition-all hover:bg-[#3d5a4e]"
              >
                <Check size={15} /> Approva
              </button>
            )}
            {status !== "rejected" && (
              <button
                data-testid={`moderation-reject-${post.post_id}`}
                onClick={() => setRejecting(true)}
                className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#CFC0B2] py-3 text-sm font-semibold text-[#8C7B6E] transition-all hover:border-[#B85328] hover:text-[#B85328]"
              >
                <X size={15} /> Rifiuta
              </button>
            )}
          </div>
        )}
      </div>
    </article>
  );
};
